import React from 'react'
import SEO from 'src/components/common/SEO'
import { videos } from 'src/constants/videos'
import { Helmet } from 'react-helmet'
import {
  Layout,
  ChannelSection,
  DealSection,
  FAQSection,
  NetworkSection,
  PlatformSection,
  HeroVideoPlayer,
} from 'src/components/common'
import { PlanCardsWithTabs } from 'src/components/common/PlanCardsWithTabs'
import { useIsTrial } from 'src/modules/hooks/useIsTrial'
import HeaderSignIn from 'src/components/common/HeaderSignIn'
import { WEB_MARKETING_HEADER_SIGN_IN } from 'src/modules/reducers/cohorts/constants'
import { useCohortFlag } from 'src/modules/hooks/useCohortFlag'

const CanadaOneboxTemplateDefault = ({
  location,
  lang = 'en',
  market = 'canada',
  ctaHrefOverride,
  ctaText,
  // Offer Code
  offerCode,
  offerBanner,
  // Metadata
  pageTitle,
  pageDescription,
  // Hero Section
  logo,
  logoHeight,
  title,
  subtitle,
  video,
  videoUrlBase,
  background,
  // Plan Cards
  hasPlanCards = true,
  plan,
  plansTitle,
  plansSubtitle,
  // Network Section
  networkHeadline,
  networkSubtitle,
  networkSet = 'canada',
  customNetworks,

  // Personalization Params
  disableFreeTrial,
  sportId,
  leagueId,
  teamId,
  // Others
  team,
  // Additional FAQs
  additionalFAQs,
  faqListOverride,
  hasPlanCardsTabs = true,
  planCardsConfig = {},
}) => {
  let metaDescription =
    pageDescription ||
    // TEMPORARY NBC DISPUTE
    // '200+ live channels. Free Cloud DVR. Watch on your phone, Roku, Apple TV, Amazon Fire TV, computer & more. FOX, NBC, CBS, NFL Network, SHOWTIME, beIN SPORTS & more.'
    '200+ live channels. Free Cloud DVR. Watch on your phone, Roku, Apple TV, Amazon Fire TV, computer & more. FOX, CBS, NFL Network, SHOWTIME, beIN SPORTS & more.'

  const isTrial = useIsTrial(market)
  const showHeaderSignIn = useCohortFlag(WEB_MARKETING_HEADER_SIGN_IN)
  disableFreeTrial = disableFreeTrial ?? !isTrial
  return (
    <Layout
      lang={lang}
      market={market}
      offerCode={offerCode}
      offerBanner={offerBanner}
      sportId={sportId}
      leagueId={leagueId}
      teamId={teamId}
    >
      <Helmet>
        <link rel="preconnect" crossOrigin="anonymous" href="https://marketing-partners.fubo.tv" />
        <link
          rel="dns-prefetch"
          crossOrigin="anonymous"
          href="https://marketing-partners.fubo.tv"
        />
      </Helmet>
      <SEO lang={lang} market={market} title={pageTitle || title} description={metaDescription} />
      {showHeaderSignIn && (
        <HeaderSignIn
          lang={lang}
          market={market}
          disableFreeTrial={disableFreeTrial}
          ctaText={ctaText}
        />
      )}
      <HeroVideoPlayer
        location={location}
        video={video || videos.generic_soccer.videoUrl}
        title={title}
        subTitle={subtitle}
        videoUrlBase={videoUrlBase}
        background={background}
        ctaText={ctaText}
        ctaHrefOverride={ctaHrefOverride}
        logo={logo}
        logoHeight={logoHeight}
        market={market}
        lang={lang}
        disableFreeTrial={disableFreeTrial}
      />
      {hasPlanCardsTabs && (
        <PlanCardsWithTabs
          lang={lang}
          market={market}
          ctaText={ctaText}
          plans={planCardsConfig.plans}
          tabs={planCardsConfig.tabs}
          activeTab={planCardsConfig.activeTab}
          overrides={planCardsConfig.overrides}
          sharedData={planCardsConfig.sharedData}
          title={plansTitle || 'Which plan is right for you?'}
          hideTabs={planCardsConfig.hideTabs}
          displayMode={planCardsConfig.displayMode}
          subtitle={
            !!plansSubtitle
              ? plansSubtitle
              : "Canada's home for streaming live soccer and top entertainment"
          }
        />
      )}
      <NetworkSection
        lang={lang}
        market={market}
        networkHeadline={networkHeadline}
        subtitle={networkSubtitle}
        networkSet={networkSet}
        customNetworks={customNetworks}
        disableFreeTrial={disableFreeTrial}
        ctaText={ctaText}
      />
      <ChannelSection
        lang={lang}
        market={market}
        showAllChannels={true}
        title="Your Fubo channel lineup"
        disableFreeTrial={disableFreeTrial}
      />
      <DealSection lang={lang} market={market} />
      <PlatformSection lang={lang} market={market} disableFreeTrial={disableFreeTrial} />
      <FAQSection
        lang={lang}
        market={market}
        team={team}
        additionalFAQs={additionalFAQs}
        faqListOverride={faqListOverride}
      />
    </Layout>
  )
}

export default CanadaOneboxTemplateDefault
